import { getDynamicSetting } from '../../../utils/dynamicSettings';

const serverUrl = getDynamicSetting('server_url');

export const BASE_URL = `${serverUrl}/integrations`;
